import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import EcoSystemBenefitsCard from "../../../../V2/Cards/EcoSystem/Benefits"

import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokEcoSystemBenefitsCard = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.EcoSystemBenefitsCard>) => {
  return (
    <EcoSystemBenefitsCard
      backgroundColor={blok.backgroundColor}
      superscriptText={blok.superscriptText}
      titleText={blok.titleText}
      descriptionText={blok.descriptionText}
      size={blok.size}
      imageUrl={blok.image.filename}
      imageAlt={blok.image.alt}
      buttonText={blok.ctaText}
      imageRounded={blok.imageRounded}
      buttonLink={storyblokLinkToYocoLink(blok.ctaLink)}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
      mobileGridOrder={mobileGridOrder}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
    />
  )
}

export default StoryblokEcoSystemBenefitsCard
